// extracted by mini-css-extract-plugin
export default {"container":"QRpdI","innerContainer":"g7bSH","voteIcon":"zMpKU","voteIconInactive":"ZSLdC","voteCount":"ncgdE"};